import { HiCheck } from "react-icons/hi";
import FilmCardItem from "../Common/FilmCardItem";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BookmarkResult = ({
  films,
  genresList,
  pageType,
  isEditing,
  selections,
  setSelections,
  isLoading,
}) => {
  return (
    <>
      {films.length === 0 && !isLoading && (
        <div className="text-white text-2xl text-center mt-10 w-full">
          <div className="flex justify-center ">
            <LazyLoadImage
              src="/empty.svg"
              alt="404Pic"
              className="w-[20vw] min-w-[250px] object-cover"
            />
          </div>
          <p className="mt-10 text-xl md:text-2xl">
            {pageType === "watchlist"
              ? "Your watchlist for this type is empty. Let's add some!"
              : "There are no films of this type you watched recently. Let's watch some! "}
          </p>
        </div>
      )}
      {films.length > 0 &&
        films.map((item) => (
          <li key={item.id} className="relative">
            <FilmCardItem item={item} genresList={genresList} />
            {isEditing && (
              <button
                onClick={() =>
                  setSelections((prev) =>
                    prev.includes(item.id)
                      ? prev.filter((id) => id !== item.id)
                      : prev.concat(item.id)
                  )
                }
                className="!w-[200px] !h-10 px-4 py-2 mt-2 text-gray-200 shadow-md shadow-gray-darken bg-gradient-to-t from-transparent to-gray-darken/60 rounded-b-md flex items-center justify-center"
              >
                <HiCheck
                  size={25}
                  className={`${
                    selections.includes(item.id) ? "opacity-100" : "opacity-25"
                  } transition duration-300 text-white`}
                />
              </button>
            )}
          </li>
        ))}
    </>
  );
};

export default BookmarkResult;
